export default "data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAACwAQCdASoQAAsAAsBMJQAAXNYbH4oAAP75v/R97kCYi3dLXwbYmLd9KoXv1WVj7ogtnX3uzYiLb/dJ+p/KAAAA";